export const IDENTIFICATION_TOKEN = 'identification-token';
export const SEATS_INVENTORY = 'seats-inventory';
export const COOKIE_ECHO_USER = 'cookie-echo-user';